import * as React from "react"
import type { SVGProps } from "react"
const SvgCreatorNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15 7.8a3.5 3.5 0 1 1 .5-1.99 8 8 0 0 1 3.43 3.2 1 1 0 1 1-1.73.99A6 6 0 0 0 15 7.8M13.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.51 15a8 8 0 0 0 4.5-1.37A3.5 3.5 0 1 0 15 18.19a6 6 0 0 1-3 .81 1 1 0 1 0-.02 2m6.09-2.99a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M4.02 13.58A8 8 0 0 1 5.06 9a1 1 0 0 1 1.73 1A6 6 0 0 0 6 13.01a3.5 3.5 0 1 1-1.98.57m3.41 2.93a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCreatorNetwork
